import React from 'react';
import MonthSpinner from '../Spinner/month-spinner/MonthSpinner';
import '../Spinner/Spinner.css';

const MonthWheel = () => {
  return(
    <div className="spinner-page">
      <MonthSpinner />
    </div>
  );
}
export default MonthWheel;